<!--安全检查总结-->
<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <h1
      style="width: 100%; height: 70px; position: absolute; color: white; font-weight: bold; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
      WSH Inspection Status
      <div class="select"
           style="position: absolute; right: 5%; z-index: 9;width: 13%;display: inline-block">
        <el-select v-model="default_tag"
                   placeholder="请选择" popper-class="optionsContent"
                   @change="switch_tag">
          <el-option
            v-for="item in multi_tags"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
    </h1>
    <div v-if="dataNotNull" key="1" class="checkDiv"
         style="width: 100%; height: 793px; position: absolute; bottom: 0">
      <div class="container1" style="height: 100%;" @click=""></div>
    </div>
    <div v-else key="2"
         style="width: 100%; height: 793px; position: absolute; bottom: 0; line-height: 793px; color: #6CF; font-size: 64px;">
      No Data !
    </div>

    <div class="check_detail" v-show="showflag" id="check_detail">
      <h1
        style="width: 100%; height: 70px; position: absolute; color: #333; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
        {{ detail_name }}
      </h1>
      <div class="close_img_gentry" @click="detailClose"></div>
      <div class="checkDiv1" style="margin-top:40px; width: 100%; height: 540px">
        <div class="container1" style="height: 100%"></div>
      </div>
    </div>
    <div class="check_detail1" v-show="showflag1">
      <h1
        style="width: 100%; height: 70px; position: absolute; color: #333; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
        {{ detail_name }}
      </h1>
      <p>{{ selected_type }}</p>
      <div class="close_img_gentry" @click="detailClose1"></div>
      <div class="inner_1">
        <div class="inner_1_item">
          <div class="inner_1_item_name">Contractor</div>
          <div class="inner_1_item_cnt">Cnt</div>
        </div>
        <div class="inner_1_item" v-for="(item, index) in wsh_con_list" :key="'wshcon_' + index">
          <div class="inner_1_item_name">{{ item.con_name }}</div>
          <div class="inner_1_item_cnt" @click="showDetail2(item.con_name)">{{ item.value }}</div>
        </div>
      </div>
    </div>
    <div class="check_detail2" v-show="showflag2">
      <h1
        style="width: 100%; height: 70px; position: absolute; color: #333; font-size: 42px; line-height: 70px; padding-left: 20px; text-align: left">
        {{ cur_con_name }}
      </h1>
      <br>
      <p style="padding: 0;margin-block-end:0">{{ selected_type }}</p>
      <div class="close_img_gentry" @click="detailClose2"></div>
      <div class="inner_2">
        <el-table
          :data="tableData"
          style="width: 98%;font-size: 24px;margin-left: 1%">
          <el-table-column
            label="SN"
            type="index"
            align="center"
            width="80">
          </el-table-column>
          <el-table-column
            prop="name"
            align="center"
            label="Person in Charge"
            width="230">
          </el-table-column>
          <el-table-column
            prop="offenders"
            align="center"
            label="Offenders"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import axios from 'axios'

export default {
  props: ['project_id'],
  name: "checks",
  data() {
    return {
      my_project_id: this.project_id,
      color: this.$store.state.color.chart_color,
      myChart: null,
      myChart1: null,
      cur_con_name: '',
      name: "checks",
      dataNotNull: true,
      period: "0",
      default_tag: "Daily",
      wsh_con_list: [],
      staff_list: {},
      tableData: [],
      multi_tags: [
        {label: "Monthly", value: "1"},
        {label: "Daily", value: "0"},
        {label: "Acc.", value: "2"},
      ],
      multi_types_first_tags: [
        {label: "Monthly", value: "1"},
        {label: "Daily", value: "0"},
        {label: "Acc.", value: "2"},
      ],
      status_tags: {
        "Pending": 0,
        "Completed": 1,
        "Time Out": 2
      },
      showflag: false,
      showflag1: false,
      showflag2: false,
      detail_name: '',
      selected_type: '',
      detail_data: [
        {
          label: 'Pending 0 0%',
          children: [],
          detail_data: []
        }, {
          label: 'Completed 0 0%',
          children: [],
          detail_data: []
        },
        {
          label: 'Time Out 0 0%',
          children: [],
          detail_data: []
        }
      ],
      defaultProps: {
        children: 'children',
        label:
          'label'
      }
    }
  }
  ,
  methods: {
    handleNodeClick(params) {
    },
    dragFunc(id) {
      var Drag = document.getElementById(id);
      Drag.onmousedown = function (event) {
        var ev = event || window.event;
        event.stopPropagation();
        var disX = ev.clientX - Drag.offsetLeft;
        var disY = ev.clientY - Drag.offsetTop;
        document.onmousemove = function (event) {
          var ev = event || window.event;
          Drag.style.left = ev.clientX - disX + "px";
          Drag.style.top = ev.clientY - disY + "px";
          Drag.style.cursor = "move";
        };
      };
      Drag.onmouseup = function () {
        document.onmousemove = null;
        this.style.cursor = "default";
      }
    },
    detailClose() {
      this.showflag = false
      this.showflag1 = false
      this.showflag2 = false
      this.myChart1.clear()
      this.myChart1.off('click')
    },
    detailClose1() {
      this.showflag1 = false
      this.showflag2 = false
    },
    detailClose2() {
      this.showflag2 = false
    },
    switch_tag(label) {
      this.sum = 0
      this.period = label
      this.getData(label)
    },
    init() {
      this.myChart.resize()
      window.addEventListener("resize", function () {
        this.myChart.resize()
      }.bind(this))
    },
    find_index(con_name) {
      for (var i in this.wsh_con_list) {
        if (this.wsh_con_list[i].con_name == con_name) {
          return i
        }
      }
      return -1
    },
    showSecond() {
      var that = this
      let postData = {
        project_id: this.my_project_id,
        period: that.period,
        user: window.localStorage.getItem("token_key"),
        // token: window.localStorage.getItem('token')
        finding_id: that.selected_type,
        status: that.status_tags[that.detail_name],
        token: "lalala"
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjCheckStatusCon", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        this.myChart.hideLoading()
        if (errNo == "0") {
          that.wsh_con_list = []
          this.showflag1 = true
          var result = resp.data.result
          for (var i in result) {
            let con_name = result[i].short_name
            let index = that.find_index(con_name)
            if (index < 0) {
              that.wsh_con_list.push({con_name: con_name, value: 1})
              that.staff_list[con_name] = []
            } else {
              that.wsh_con_list[index].value += 1
            }
            let offenders = ''
            if (result[i].offenders) {
              for (var j in result[i].offenders) {
                offenders += result[i].offenders[j].user_name
              }
            }
            that.staff_list[con_name].push({name: result[i].charge_name, offenders: offenders})
          }
        }
      })
    },
    analysisResult(result) {
      // {status: "进行中", count: "4"} Ongoing
      // {status: "已回复", count: "119"} Closed
      // {status: "未回复", count: "8"} Time Out

      var checkes = [
        {name: 'Pending', value: 0},
        {name: 'Completed', value: 0},
        {name: 'Time Out', value: 0}
      ]
      var totle = []
      var assists = []
      var total = 0
      var assist = 0
      var pend_chid = []
      var comp_chid = []
      var timeout = []
      for (var i in result) {
        var status = result[i].status
        var count = result[i].count
        if (status == '0') {
          total += parseInt(count)
          checkes[0].value += parseInt(count)
        } else if (status == '1') {
          total += parseInt(count)
          checkes[1].value += parseInt(count)
        } else if (status == '2') {
          total += parseInt(count)
          checkes[2].value += parseInt(count)
        }
      }
      this.detail_data[0].children = []
      this.detail_data[1].children = []
      this.detail_data[2].children = []
      this.detail_data[0].detail_data = []
      this.detail_data[1].detail_data = []
      this.detail_data[2].detail_data = []
      for (var i in result) {
        var finding = result[i].findings_name_en
        var count = result[i].count
        var status = result[i].status
        this.detail_data[parseInt(status)].label = checkes[parseInt(status)].name + " ( " + checkes[parseInt(status)].value + ", " + ((checkes[parseInt(status)].value / total).toFixed(4) * 100).toFixed(2) + "% )"
        this.detail_data[parseInt(status)].children.push({label: finding + " ( " + count + ", " + ((count / checkes[parseInt(status)].value).toFixed(4) * 100).toFixed(2) + "% )"})
        this.detail_data[parseInt(status)].detail_data.push(
          {name: finding, value: count}
        )
      }
      total *= 1.2
      assist = total / 6
      for (var i in checkes) {
        var name = checkes[i].name
        var value = parseInt(checkes[i].value) + assist
        assists.push({name: name, value: value})
        totle.push({name: name, value: total})
      }
      return {checkes: checkes, assists: assists, totle: totle, assist: assist}
    },
    //获取当前日期，格式YYYY-MM-DD
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    getData(period) {
      var that = this
      let postData = {
        project_id: this.my_project_id,
        // start_date: this.getNowFormatDate(),
        // end_date: this.getNowFormatDate(),
        period: period,
        user: window.localStorage.getItem("token_key"),
        // token: window.localStorage.getItem('token')
        token: "lalala"
      }
      axios.post(this.$store.getters.getCmsServer + "DBProjCheckStatus", postData).then(resp => {
        var errNo = resp.data.errno
        var errStr = resp.data.errstr_cn
        this.myChart.hideLoading()
        if (errNo == "0") {
          this.dataNotNull = true
          that.$nextTick().then(() => {
            that.init_chart()
            var result = resp.data.result;
            var data = this.analysisResult(result)
            this.myChart.setOption({
              series: [
                {
                  data: data.totle
                },
                {
                  data: data.assists,
                  label: {
                    normal: {
                      show: true,
                      color: '#6cf',
                      position: 'insideRight',
                      formatter: function (params) {
                        return parseInt(params.value) - parseInt(data.assist);
                      }
                    }
                  },
                },
                {
                  data: data.checkes
                }
              ]
            })
          })
        } else {
          this.dataNotNull = false
        }
      }).catch(error => {
        alert(error)
        this.myChart.hideLoading()
        this.dataNotNull = false
      })
    },
    init_chart() {
      let that = this
      this.myChart = echarts.init(document.querySelector('.checkDiv .container1'))
      this.myChart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function (params) {
            return params[1].name + ':  ' + Math.round(params[2].value * 120 / params[0].value) + '%';
          },
          textStyle: {
            fontSize: '40'
          }
        },
        grid: {
          left: 330
        },
        xAxis: {
          type: 'value',
          show: false,
          axisLabel: {
            formatter: '{value}'
          }
        },
        yAxis: {
          type: 'category',
          inverse: true,
          data: ['Pending', 'Completed', 'Time Out'],
          axisLine: {
            show: true,
            lineStyle: {
              color: '#6CF'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            margin: 15,
            show: true,
            textStyle: {
              color: '#FFF',
              fontSize: 42
            }
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name: '总计',
            type: 'bar',
            barGap: '-100%',
            barWidth: '60%',
            label: {
              normal: {
                show: false,
                color: '#6cf',
                position: 'insideRight',
              }
            },
            itemStyle: {
              normal: {
                color: '#00000000',
                borderColor: '#999',
                borderWidth: '0',
              }
            },
            data: []
          },
          {
            name: '总计',
            type: 'bar',
            barGap: '-100%',
            barWidth: '60%',
            label: {
              normal: {
                show: true,
                color: '#6cf',
                position: 'insideRight',
                formatter: '{c}',
                textStyle: {
                  fontSize: 42
                }
              }
            },
            itemStyle: {
              normal: {
                color: '#00000000',
              }
            },
            data: []
          },
          {
            name: '总计',
            type: 'bar',
            barWidth: '60%',
            data: [],
            label: {
              normal: {
                show: false,
                formatter: '{b}'
              }
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return that.color[params.dataIndex]
                },
              }
            },
          }
        ]
      })
      this.myChart.on('click', function (param) {
        var name = param.data.name // 'Completed', 'Pending', 'Time Out'
        that.showDetail(name)
      })
    },
    showDetail(name) {
      let that = this
      var detail_data_one = []
      if (name == 'Pending') {
        detail_data_one = this.detail_data[0].detail_data
      } else if (name == 'Completed') {
        detail_data_one = this.detail_data[1].detail_data
      } else {
        detail_data_one = this.detail_data[2].detail_data
      }
      if (detail_data_one.length == 0) {
        return
      }
      this.detail_name = name

      that.showflag = true
      this.$nextTick(() => {
        this.myChart1 = echarts.init(document.querySelector('.checkDiv1 .container1'))
        this.myChart1.setOption({
          tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)",
            textStyle: {
              fontSize: 40
            }
          },
          legend: {
            orient: 'vertical',
            x: 'right',
            left: '48%',
            top: '10%',
            itemGap: 24,
            itemHeight: '28',
            itemWidth: 80,
            // selectedMode: false,
            click: function (event, legendItem) {
              var qualityName = legendItem.text;
              //获取图例名称
            },
            textStyle: {
              color: '#333',
              fontSize: '26'
            },
            data: []
          },
          series: [{
            name: 'PTW',
            data: [],
            type: 'pie',
            hoverOffset: 5,
            radius: ['45%', '65%'],
            center: ['25%', '50%'],
            label: {
              normal: {
                show: true,
                position: 'inside',
                formatter: '{c}',
                textStyle: {
                  fontSize: '36',
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: '48',
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },

            itemStyle: {
              normal: {
                color: function (params) {
                  return that.color[params.dataIndex]
                }
              },
              //鼠标悬停时：
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
                borderWidth: 1
              }
            }
          }],
        })
        that.myChart1.on('legendselectchanged', function (params) {
          that.selected_type = params.name
          that.showSecond()
        })
        var values = []
        var legends = []
        detail_data_one.forEach(item => {
          values.push({
            name: item.name,
            value: item.value
          })
          legends.push(item.name)
        })
        this.myChart1.setOption({
          legend: {
            data: legends,
          },
          series: [{
            data: values
          }]
        })
      })
    },
    showDetail2(params) {
      this.cur_con_name = params
      this.showflag2 = true
      this.tableData = this.staff_list[this.cur_con_name]
    }
  },
  beforeDestroy() {
    if (this.myChart) {
      this.myChart.clear()
    }
    if (this.myChart1) {
      this.myChart1.clear()
    }
  },
  mounted() {
    var name = window.localStorage.getItem('token_key')
    if ("videmo" == name) {
      this.my_project_id = "3177"
    }
    this.init_chart()
    this.getData('0')
    // this.init()
    this.dragFunc("check_detail")
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.check_detail {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  position: absolute;
  width: 90%;
  height: 80%;
  left: 5%;
  top: 12%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
  color #333333
}

.check_detail1 {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  box-shadow: inset 0px 0px 5px 1px #66CCFF;
  position: absolute;
  width: 80%;
  height: 70%;
  left: 10%;
  top: 18%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
  color #333333
}

.check_detail2 {
  background-color: rgb(248, 248, 248);
  border-width: 2px;
  border-color: #2db7f5;
  border-radius: 10px;
  box-shadow: inset 0px 0px 5px 1px #66CCFF;
  position: absolute;
  width: 70%;
  height: 65%;
  left: 15%;
  top: 20%;
  text-align: center;
  font-size: 40px;
  z-index: 1000;
  color #333333
}

.inner_1 {
  display flex
  flex-direction column
  width 100%
  width: 100%;
  height: 480px;
  overflow scroll
}

.inner_1_item {
  display flex
  width 100%
  height 80px
}

.inner_1_item_name {
  width 75%
  height 80px
  line-height 80px
  text-align center
}

.inner_1_item_cnt {
  width 25%
  height 80px
  line-height 80px
  text-align center
}

.inner_2 {
  display flex
  flex-direction column
  width 100%
  /*margin-top: 120px;*/
  width: 100%;
  height: 420px;
  overflow scroll
}

.inner_2_item {
  display flex
  width 100%
  height 80px
}

.inner_2_item_border {
  display flex
  width 100%
  margin-top 20px
}

.inner_2_item_index {
  width 10%
  height 80px
  line-height 80px
}

.with_border {
  width 87%
  border 1px solid black
  display flex
}

.inner_2_item_name {
  width 55%
  height 80px
  line-height 80px
  text-align center
}

.inner_2_item_cnt {
  width 45%
  height 80px
  line-height 80px
  text-align center
}

.inner_2_item_name_border {
  width 50%
  text-align center
  border-right 1px solid black
  display flex
  flex-direction column
}

.inner_2_item_cnt_border {
  width 50%
  text-align center
  display flex
  flex-direction column
}

.inner_2_item_cnt_border_one {
  width 100%
  height 60px
  line-height 60px
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.close_img {
  position: absolute;
  background-image: url("../../assets/close.png");
  background-repeat: no-repeat;
  right: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
}

.el-tree-node__label {
  font-size: 30px;
}

.el-tree-node__expand-icon {
  font-size: 30px;
}

.el-tree-node__content {
  height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/safety_manage/check.vue